import {
    ZAJAVLS,
    LOADING_ZAJAVLS,
    LOADED_ZAJAVLS,
    CONTEST_DIALOG_OPEN_ZAJAVLS,
    CONTEST_EDIT_FORM_ZAJAVLS,
    ZAJAVL_EDIT_UUID_ZAJAVLS,
    SPR_COMPETITIONS_ZAJAVLS,
    SPR_ALLOWED_FOR_ADMISSION_COMP_GROUPS_NAMES,
    ALLOWED_ONLINE_ZAJAVLS,
    REQUIREMENTS_DOCUMENTS_ZAJAVLS,
    TEMPLATES_DOCUMENTS_ZAJAVLS,
    ZAJAVLS_CONSENT_OR_REFUSAL_PAGE_LOADED,
    COMMENTS_ZAJAVLS,
    HISTORY_ZAJAVL,
    LOADING_HISTORY_ZAJAVL,
} from '../store/actionTypes';

export const zajavls = (state = [], action) => {
    switch (action.type) {
        case ZAJAVLS:
            return action.list;
        default:
            return state;
    }
};
export const loadingZajavls = (state = false, action) => {
    switch (action.type) {
        case LOADING_ZAJAVLS:
            return action.status;
        default:
            return state;
    }
};
export const loadedZajavls = (state = false, action) => {
    switch (action.type) {
        case LOADED_ZAJAVLS:
            return action.status;
        default:
            return state;
    }
};
export const contestDialogOpenZajavls = (state = false, action) => {
    switch (action.type) {
        case CONTEST_DIALOG_OPEN_ZAJAVLS:
            return action.status;
        default:
            return state;
    }
};
export const contestEditFormZajavls = (state = {}, action) => {
    switch (action.type) {
        case CONTEST_EDIT_FORM_ZAJAVLS:
            return action.object;
        default:
            return state;
    }
};
export const zajavlEditUuidZajavls = (state = '', action) => {
    switch (action.type) {
        case ZAJAVL_EDIT_UUID_ZAJAVLS:
            return action.value;
        default:
            return state;
    }
};
export const sprCompetitionsZajavls = (state = [], action) => {
    switch (action.type) {
        case SPR_COMPETITIONS_ZAJAVLS:
            return action.payload;
        default:
            return state;
    }
};

export const sprAllowedForAdmissionCompGroupsNames = (state = {}, action) => {
    switch (action.type) {
        case SPR_ALLOWED_FOR_ADMISSION_COMP_GROUPS_NAMES:
            return action.object;
        default:
            return state;
    }
};

export const allowedOnlineZajavls = (state = false, action) => {
    switch (action.type) {
        case ALLOWED_ONLINE_ZAJAVLS:
            return action.status;
        default:
            return state;
    }
};
export const requirementsDocuments = (state = [], action) => {
    switch (action.type) {
        case REQUIREMENTS_DOCUMENTS_ZAJAVLS:
            return action.list;
        default:
            return state;
    }
};
export const templatesDocuments = (state = {}, action) => {
    switch (action.type) {
        case TEMPLATES_DOCUMENTS_ZAJAVLS:
            return action.object;
        default:
            return state;
    }
};
export const zajavlsConsentOrRefusalPageLoaded = (state = false, action) => {
    switch (action.type) {
        case ZAJAVLS_CONSENT_OR_REFUSAL_PAGE_LOADED:
            return action.status;
        default:
            return state;
    }
};
export const commentsZajavls = (state = [], action) => {
    switch (action.type) {
        case COMMENTS_ZAJAVLS:
            return action.list;
        default:
            return state;
    }
};
export const historyZajavl = (state = [], action) => {
    switch (action.type) {
        case HISTORY_ZAJAVL:
            return action.list;
        default:
            return state;
    }
};
export const loadingHistoryZajavl = (state = false, action) => {
    switch (action.type) {
        case LOADING_HISTORY_ZAJAVL:
            return action.status;
        default:
            return state;
    }
};
